export var dropdownPrefixSelector = 'pm-dropdown';
export var DropdownMenuSharedCssClassName = {
  SUBMENU: "".concat(dropdownPrefixSelector, "-submenu")
};